import type { AssessmentQuestion } from '@entities/assessment'

import { AssessmentTopics } from '@entities/assessment'

import imgQuestion2 from '../../../../ui/images/questions/ela/grade-k8/question-2.png'
import imgQuestion4 from '../../../../ui/images/questions/ela/grade-k8/question-4.png'
import imgQuestion7 from '../../../../ui/images/questions/ela/grade-k8/question-7.png'

export const questions: AssessmentQuestion[] = [
  {
    name: 'grade_k8_1',
    title: 'If someone says, “She spilled the beans,” what does that mean?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    answers: [
      {
        name: 'grade_k8_1_a',
        text: 'She dropped her lunch.',
      },
      {
        name: 'grade_k8_1_b',
        text: 'She revealed a secret.',
        correct: true,
      },
      {
        name: 'grade_k8_1_c',
        text: 'She planted vegetables.',
      },
    ],
  },
  {
    name: 'grade_k8_2',
    title: 'How should you respond if you disagree with someone’s opinion during a discussion?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    image: imgQuestion2,
    answers: [
      {
        name: 'grade_k8_2_a',
        text: 'Interrupt and speak louder.',
      },
      {
        name: 'grade_k8_2_b',
        text: 'Listen carefully and share your opinion respectfully.',
        correct: true,
      },
      {
        name: 'grade_k8_2_c',
        text: 'Ignore their opinion and change the subject.',
      },
    ],
  },
  {
    name: 'grade_k8_3',
    title: 'You hear these instructions:',
    topic: AssessmentTopics.ListeningAndSpeaking,
    detail: '“Please review your answers carefully, then submit your test quietly and wait for further instructions.”',
    sentence: 'What should you do first?',
    answers: [
      {
        name: 'grade_k8_3_a',
        text: 'Submit your test.',
      },
      {
        name: 'grade_k8_3_b',
        text: 'Wait for instructions.',
      },
      {
        name: 'grade_k8_3_c',
        text: 'Review your answers carefully.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k8_4',
    title: 'What is the main idea of the passage?',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: 'The old library was a quiet place, filled with dusty shelves and worn books. Emma loved spending her afternoons there, lost in stories of faraway places and daring adventures. Even though the building was old, it held a special magic that made every visit feel like a journey.',
    image: imgQuestion4,
    answers: [
      {
        name: 'grade_k8_4_a',
        text: 'The library needs repairs.',
      },
      {
        name: 'grade_k8_4_b',
        text: 'Emma enjoys visiting the library because of the stories it holds.',
        correct: true,
      },
      {
        name: 'grade_k8_4_c',
        text: 'The library is full of dust and old books.',
      },
    ],
  },
  {
    name: 'grade_k8_5',
    title: 'What does the word “daring” most likely mean in this passage?',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: 'The old library was a quiet place, filled with dusty shelves and worn books. Emma loved spending her afternoons there, lost in stories of faraway places and daring adventures. Even though the building was old, it held a special magic that made every visit feel like a journey.',
    answers: [
      {
        name: 'grade_k8_5_a',
        text: 'Boring',
      },
      {
        name: 'grade_k8_5_b',
        text: 'Brave and adventurous',
        correct: true,
      },
      {
        name: 'grade_k8_5_c',
        text: 'Old and worn',
      },
    ],
  },
  {
    name: 'grade_k8_6',
    title: 'What is the main idea of the passage?',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: 'Climate change is a global issue that affects weather patterns, sea levels, and ecosystems around the world. Scientists agree that human activities, such as burning fossil fuels and deforestation, are major contributors to climate change. Efforts to reduce carbon emissions and protect natural habitats are essential to slowing this process.',
    answers: [
      {
        name: 'grade_k8_6_a',
        text: 'Climate change is caused only by natural events.',
      },
      {
        name: 'grade_k8_6_b',
        text: 'Human activities significantly contribute to climate change.',
        correct: true,
      },
      {
        name: 'grade_k8_6_c',
        text: 'Climate change has no effect on ecosystems.',
      },
    ],
  },
  {
    name: 'grade_k8_7',
    title: 'She showed great _______ when solving the difficult problem.',
    topic: AssessmentTopics.Writing,
    image: imgQuestion7,
    answers: [
      {
        name: 'grade_k8_7_a',
        text: 'confusion',
      },
      {
        name: 'grade_k8_7_b',
        text: 'fear',
      },
      {
        name: 'grade_k8_7_c',
        text: 'patience',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k8_8',
    title: 'Which sentence uses transition words and punctuation correctly?',
    topic: AssessmentTopics.Writing,
    answers: [
      {
        name: 'grade_k8_8_a',
        text: 'I wanted to go swimming, but the pool was closed so I stayed home.',
      },
      {
        name: 'grade_k8_8_b',
        text: 'I wanted to go swimming; however, the pool was closed, so I stayed home.',
        correct: true,
      },
      {
        name: 'grade_k8_8_c',
        text: 'I wanted to go swimming however the pool was closed so I stayed home.',
      },
    ],
  },
  {
    name: 'grade_k8_9',
    title: 'Choose the sentence that is written as a complex sentence:',
    topic: AssessmentTopics.Writing,
    answers: [
      {
        name: 'grade_k8_9_a',
        text: 'She enjoys reading books and watching movies.',
      },
      {
        name: 'grade_k8_9_b',
        text: 'Although it was raining, we decided to go for a walk.',
        correct: true,
      },
      {
        name: 'grade_k8_9_c',
        text: 'We went to the park and had a picnic.',
      },
    ],
  },
  {
    name: 'grade_k8_10',
    title: 'Which sentence uses the correct form of the verb?',
    topic: AssessmentTopics.Language,
    answers: [
      {
        name: 'grade_k8_10_a',
        text: 'Neither of the students were ready for the test.',
      },
      {
        name: 'grade_k8_10_b',
        text: 'Neither of the students was ready for the test.',
        correct: true,
      },
      {
        name: 'grade_k8_10_c',
        text: 'Neither of the students are ready for the test.',
      },
    ],
  },
  {
    name: 'grade_k8_11',
    title: 'Identify the preposition in this sentence:\nThe cat jumped over the fence to catch the bird.',
    topic: AssessmentTopics.Language,
    answers: [
      {
        name: 'grade_k8_11_a',
        text: 'jumped',
      },
      {
        name: 'grade_k8_11_b',
        text: 'catch',
      },
      {
        name: 'grade_k8_11_c',
        text: 'over',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k8_12',
    title: 'Which sentence is written in the active voice?',
    topic: AssessmentTopics.Language,
    answers: [
      {
        name: 'grade_k8_12_a',
        text: 'The dog chased the ball.',
        correct: true,
      },
      {
        name: 'grade_k8_12_b',
        text: 'The ball was chased by the dog.',
      },
      {
        name: 'grade_k8_12_c',
        text: 'The ball was thrown by the boy.',
      },
    ],
  },
]
